import { SET_APP_CONFIGS, SetAppConfigsAction } from '../types'

const initialState = {}

const financialStatementConfigReducer = (state = initialState, action: SetAppConfigsAction) => {
  switch (action.type) {
    case SET_APP_CONFIGS:
      return action.payload.financialStatement
    default:
      return state
  }
}

export default financialStatementConfigReducer
